import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Route, Routes } from "react-router-dom";
import { loggedInUserUrls, getOrgById } from "./services/index";
import Cookies from "universal-cookie";

// INVENTORY
import IssuanceList from "./components/Inventory/issuance/IssuanceList";
import IssuanceView from "./components/Inventory/issuance/IssuanceView";
import IssuanceNew from "./components/Inventory/issuance/IssuanceNew";
import ItemList from "./components/Inventory/item/ItemList";
import ItemView from "./components/Inventory/item/ItemView";
import ItemNew from "./components/Inventory/item/ItemNew";

import PriceList from "./components/Inventory/priceList/PriceList";
import PriceListNew from "./components/Inventory/priceList/PriceListNew";
import PriceListView from "./components/Inventory/priceList/PriceListView";

// SALES
import CustomerList from "./components/Sales/customer/CustomerList";
import CustomerNew from "./components/Sales/customer/CustomerNew";
import CustomerView from "./components/Sales/customer/CustomerView";

import SalesNew from "./components/Sales/sales/SalesNew";
import SalesView from "./components/Sales/sales/SalesView";
import SalesList from "./components/Sales/sales/SalesList";

import InvoiceList from "./components/Sales/invoice/InvoiceList";
import InvoiceView from "./components/Sales/invoice/InvoiceView";

import CreditNoteView from "./components/Sales/creditNote/CreditNoteView";
import DebitNoteView from "./components/Purchase/debitNote/DebitNoteView";
// import CreateCreditNote from "./components/Sales/creditNote/CreateCreditNote";

import PaySales from "./components/Sales/paySales/PaySales";
import PaySalesList from "./components/Sales/paySales/PaySalesList";

// PURCHASE

import BillList from "./components/Purchase/bills/BillList";
import BillView from "./components/Purchase/bills/BillView";

import VendorNew from "./components/Purchase/vendors/VendorNew";
import VendorView from "./components/Purchase/vendors/VendorView";
import VendorList from "./components/Purchase/vendors/VendorList";

import PurchaseNew from "./components/Purchase/purchase/PurchaseNew";
import PurchaseView from "./components/Purchase/purchase/PurchaseView";
import PurchaseList from "./components/Purchase/purchase/PurchaseList";

import PayPurchase from "./components/Purchase/PayPurchase";
import PayPurchaseList from "./components/Purchase/PayPurchaseList";

// PRODUCTION
import RequisitionList from "./components/Production/requisition/RequisitionList";
import RequisitionView from "./components/Production/requisition/RequisitionView";
import RequisitionNew from "./components/Production/requisition/RequisitionNew";

import RecipeList from "./components/Production/recipe/RecipeList";
import RecipeNew from "./components/Production/recipe/RecipeNew";
import RecipeView from "./components/Production/recipe/RecipeView";

import BatchList from "./components/Production/batch/BatchList";
import BatchNew from "./components/Production/batch/BatchNew";
import BatchView from "./components/Production/batch/BatchView";

// SETTINGS
import AccessDenied from "./components/Common/AccessDenied";
import AssignRoles from "./components/Settings/AssignRoles";
import TermsConditionList from "./components/Settings/TermsConditionList";
import DepartmentList from "./components/Settings/DepartmentList";
import DeliveryPersonList from "./components/Settings/DeliveryPersonList";
import HsnList from "./components/Settings/HsnList";
import TaxExempt from "./components/Settings/TaxExempt";
import PaymentTerms from "./components/Settings/PaymentTerms";
import ViewReports from "./components/Reports/ViewReports";
// import Warehouses from "./components/Settings/Warehouses";
// import UserAndRoles from "./components/Settings/UserAndRoles";
// import TaxList from "./components/Settings/TaxList";
// import OrgList from "./components/Settings/Organization";
import UnitList from "./components/Settings/UnitList";
import DefaultUrlList from "./components/Settings/DefaultUrlList";
import EWay from "./components/Settings/EWay";

import Dashboard from "./components/Common/Dashboard";
import TDSList from "./components/Settings/TDSList";
import SalesPersonList from "./components/Settings/SalesPersonList";
import Categories from "./components/Settings/Categories";
import StockClosingNew from "./components/Inventory/stockClosing/StockClosingNew";
import StockClosingList from "./components/Inventory/stockClosing/StockClosingList";
import WastageList from "./components/Inventory/wastage/WastageList";
import WastageNew from "./components/Inventory/wastage/WastageNew";
import StockClosingView from "./components/Inventory/stockClosing/StockClosingView";
import WastageView from "./components/Inventory/wastage/WastageView";
import { SET_AUTH_URLS, SET_USER_ROLES } from "./context/actions/action";
import { AuthUrlContext } from "./context/createContext";
import CustomCategory from "./components/Settings/CustomCategory";
import { CUSTOM_CATEGORY_COMPONENT_TYPE } from "./components/utils/utilsConstants";
import BillNew from "./components/Purchase/bills/BillNew";
import Store from "./components/Settings/Store";
import Warehouses from "./components/Settings/Warehouses";
import UserAndRoles from "./components/Settings/UserAndRoles";
import TaxList from "./components/Settings/TaxList";
import OrgList from "./components/Settings/Organization";
import TCS from "./components/Settings/TCS";
import Rack from "./components/Settings/Rack";
import Cell from "./components/Settings/Cell";
import PreferencesNav from "./components/Settings/PreferencesNav";
import InvoiceNew from "./components/Sales/invoice/InvoiceNew";
import StockTransferList from "./components/Inventory/stockTransfer/StockTransferList";
import StockTransferRecieved from "./components/Inventory/stockTransfer/StockTransferRecieved";
import StockTransferNew from "./components/Inventory/stockTransfer/StockTransferNew";
import StockTransferView from "./components/Inventory/stockTransfer/stockTransferView";
import StoreTransferList from "./components/Inventory/storeTransfer/StoreTransferList";
import StoreTransferNew from "./components/Inventory/storeTransfer/StoreTransferNew";
import StoreTransferView from "./components/Inventory/storeTransfer/StoreTransferView";
import Pallet from "./components/Settings/Pallet";
import QualityParameter from "./components/Settings/QualityParameter";
import DepartmentStockClosingList from "./components/Production/stockClosing/StockClosingList";
import DepartmentStockClosingNew from "./components/Production/stockClosing/StockClosingNew";
import DepartmentStockClosingView from "./components/Production/stockClosing/StockClosingView";
import PickList from "./components/Sales/PickLst/PickList";
import ItemsListPriceList from "./components/Inventory/PriceListitems/ItemsListPriceList";
import { AddEditFGitemsales } from "./components/Inventory/FGitems/AddEditFGitemsales";
import FGsalesList from "./components/Inventory/FGitems/FGsalesList";
import { FGItemsView } from "./components/Inventory/FGitems/FGItemsView";

const Routing2 = () => {
    const { dispatchUserRights, userRights } = useContext(AuthUrlContext)
    const { urlList, userRole } = userRights

    useEffect(() => {

        loggedInUserUrls().then((res) => {
            if (res.errorCode === 0) {
                let urlSet = new Set();
                const { urlList, adminRoleEnum } = res.responsePacket
                const length = urlList.length
                for (let i = 0; i < length; i++) {
                    const { url, urlId } = urlList[i]
                    urlSet.add(url)
                    urlSet.add(urlId)
                }
                dispatchUserRights({ type: SET_AUTH_URLS, payload: urlSet })
                dispatchUserRights({ type: SET_USER_ROLES, payload: adminRoleEnum })

            } else if (res.message === 'Unauthorised Access') {
                // Logout
                const cookies = new Cookies()
                cookies.remove("loginData1");
                cookies.remove("pyAuth");

                setTimeout(() => {
                    window.location.reload(24);
                }, 1000);

                // setHeaderLogout(true);
            } else {
                toast.error(res.message);
            }
        });

        let loginData1 = new Cookies().get("loginData1");
        if (loginData1) {
            let orgId = loginData1.organisationId;

            getOrgById(orgId).then((res) => {
                if (res.errorCode === 0) {
                    let d = res.responsePacket;
                    localStorage.setItem("orgDetail", JSON.stringify(d));
                } else {
                    toast(res.message);
                }
            });
        }
    }, []);

    let superAdmin = userRole === "ROLE_SUPER_ADMIN";

    return (
        <>
            <div id="main-content">
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    {superAdmin ? (
                        <>
                            {/* <Route path="/settings/userRole" element={<UserAndRoles />} />
                            <Route path="/settings/warehouse" element={<Warehouses />} />
                            <Route path="/settings/taxes/taxList" element={<TaxList />} /> */}
                            {/* <Route path="/settings/userRole/AssignRoles/:id" element={<AssignRoles />} /> */}
                            {/* <Route path="/settings/orgList" element={<OrgList />} /> */}
                        </>
                    ) : (
                        <></>
                    )}
                    {superAdmin || (urlList && urlList.has("/vendor/getAllRecords")) ? <Route path="/vendors" element={<VendorList />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/vendor/")) ? <Route path="/vendors/new" element={<VendorNew />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/vendor/{uuid}")) ? <Route path="/vendors/:id" element={<VendorView />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("1235383e-bb66-449e-abce-2be0180ee260")) ? <Route path="/vendors/:id/edit" element={<VendorNew />} /> : <></>}

                    {superAdmin || (urlList && urlList.has("/purchaseOrder/getAllRecords")) ? <Route path="/purchase/" element={<PurchaseList />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/purchaseOrder/")) ? <Route path="/purchase/new" element={<PurchaseNew />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("bcf25509-49b7-4629-8244-2940073f027f")) ? <Route path="/purchase/:id/edit" element={<PurchaseNew />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/purchaseOrder/{uuid}")) ? <Route path="/purchase/:id" element={<PurchaseView />} /> : <></>}

                    {superAdmin || (urlList && urlList.has("/PurchasePayment/getAllRecords")) ? <Route path="/purchasePaymentlist" element={<PayPurchaseList />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/PurchasePayment/PurchasePayment/{uuid}")) ? (
                        <Route path="/purchasePayment/:id" element={<PayPurchase />} />
                    ) : (
                        <></>
                    )}
                    {superAdmin || (urlList && urlList.has("/bill/getAllRecords")) ? <Route path="/bills" element={<BillList />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/bill/addDirectBillRecord/")) ? <Route path="/DirectBill" element={<BillNew />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/bill/{uuid}")) ? <Route path="/bills/:id" element={<BillView />} /> : <></>}
                    <Route path="/convertbill/:id/" element={<BillNew />} />

                    {superAdmin || (urlList && urlList.has("/batches/getAllRecords")) ? <Route path="/batches" element={<BatchList />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/batches/")) ? <Route path="/batches/new" s element={<BatchNew />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/batches/{uuid}")) ? <Route path="/batches/:id" element={<BatchView />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("d7cf0517-05fa-49df-a55f-3896be0ceb22")) ? <Route path="/batches/:id/edit" element={<BatchNew />} /> : <></>}

                    {superAdmin || (urlList && urlList.has("/recipe/getAllRecords")) ? <Route path="/recipe" element={<RecipeList />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/recipe/")) ? <Route path="/recipe/new" element={<RecipeNew />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/recipe/{uuid}")) ? <Route path="/recipe/:id" element={<RecipeView />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("395696ce-6009-411b-863b-0bfe5f2898d0")) ? <Route path="/recipe/:id/edit" element={<RecipeNew />} /> : <></>}

                    {superAdmin || (urlList && urlList.has("/salesOrder/getAllRecords")) ? <Route path="/salesorders" element={<SalesList superAdmin={superAdmin} urlList={urlList} />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/salesOrder/")) ? <Route path="/salesorders/new" element={<SalesNew />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/salesOrder/{uuid}")) ? <Route path="/salesorders/:id" element={<SalesView superAdmin={superAdmin} urlList={urlList} />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("c02b1c1b-5036-4527-8043-2f2d70c10a5d") || urlList.has("c109bc3a-2147-4880-80f8-8ab54e7774d3")) ? <Route path="/salesorders/:id/edit" element={<SalesNew />} /> : <></>}
                    {/* {superAdmin || (urlList && urlList.has("c109bc3a-2147-4880-80f8-8ab54e7774d3")) ? <Route path="/salesorders/:id/edit" element={<SalesNew />} /> : <></>} */}

                    {superAdmin || (urlList && urlList.has("/recordPayment/recordPayment/{uuid}")) ? <Route path="/SalesPayment/:id" element={<PaySales />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/recordPayment/getAllRecords")) ? <Route path="/salesPaymentlist" element={<PaySalesList />} /> : <></>}

                    {superAdmin || (urlList && urlList.has("/invoice/getAllRecords")) ? <Route path="/invoices" element={<InvoiceList />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/invoice/")) ? <Route path="/invoices/new" element={<InvoiceNew type={"new"} />} /> : <></>}
                    <Route path="/invoiceEdit" element={<InvoiceNew />} />
                    {superAdmin || (urlList && urlList.has("/invoice/addDirectInvoiceRecord")) ? <Route path="/directInvoices" element={<InvoiceNew type={"new"} />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/invoice/{uuid}")) ? <Route path="/invoices/:id" element={<InvoiceView />} /> : <></>}

                    {superAdmin || (urlList && urlList.has("/customer/getAllRecords")) ? <Route path="/contacts" element={<CustomerList />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/customer/")) ? <Route path="/contacts/new" element={<CustomerNew />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/customer/{uuid}")) ? <Route path="/contacts/:id" element={<CustomerView />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("0dabfdcb-b89c-4b30-9c0e-e8c72edc785f")) ? <Route path="/contacts/:id/edit" element={<CustomerNew />} /> : <></>}

                    {superAdmin || (urlList && urlList.has("/itemPriceList/getAllRecords")) ? <Route path="/pricelists" element={<PriceList />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/itemPriceList/")) ? <Route path="/pricelist/new" element={<PriceListNew />} /> : <></>}
                    {superAdmin ? <Route path="/ItemsPriceList" element={<ItemsListPriceList />} /> : <></>}
                    <Route path="/pricelists/:id" element={<PriceListView />} />
                    {superAdmin || (urlList && urlList.has("7d5578a1-149e-4592-b886-9f819eb09228")) ? (
                        <Route path="/pricelists/:id/edit" element={<PriceListNew />} />
                    ) : (
                        <></>
                    )}

                    {superAdmin || (urlList && urlList.has("/items/getAllRecords")) ? <Route path="/items" element={<ItemList />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/items/")) ? <Route path="/items/new" element={<ItemNew />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/items/{uuid}")) ? <Route path="/items/:id/edit" element={<ItemNew />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/items/UUID/{uuid}")) ? (
                        <>
                            <Route path="/items/:warehouseId/:id" element={<ItemView />} />
                            <Route path="/items/:id" element={<ItemView />} />
                        </>
                    ) : (
                        <></>
                    )}

                    {superAdmin || (urlList && urlList.has("/issuance/getAllRecords")) ? <Route path="/issueitems" element={<IssuanceList />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/issuance/")) ? <Route path="/issueitems/new" element={<IssuanceNew />} /> : <></>}
                    {superAdmin || (urlList && urlList.has("/issuance/{uuid}")) ? <Route path="/issueitems/:id" element={<IssuanceView />} /> : <></>}

                    {(superAdmin || (urlList && urlList.has("/stockClosing/warehouseList/{warehouse}"))) && <Route path="/stockClosing/list" element={<StockClosingList />} />}
                    {(superAdmin || (urlList && urlList.has("/stockTransfer/getAllRecords"))) && <Route path="/stockTransfer/list" element={<StockTransferList />} />}
                    {(superAdmin || (urlList && urlList.has("/stockTransfer/approved/{uuid}"))) && <Route path="/stockTransferReceived/list" element={<StockTransferRecieved />} />}
                    {(superAdmin || (urlList && urlList.has("/stockClosing/{uuid}"))) && <Route path="/stockClosing/new" element={<StockClosingNew />} />}
                    {(superAdmin || (urlList && urlList.has("/stockTransfer/{uuid}"))) && <Route path="/stockTransfer/new" element={<StockTransferNew />} />}
                    {(superAdmin || (urlList && urlList.has("/stockTransfer/{uuid}"))) && <Route path="/stockTransfer/:id/edit" element={<StockTransferNew />} />}
                    {(superAdmin || (urlList && urlList.has("/stockClosing/{uuid}/{code}"))) && <Route path="/stockClosing/:warehouseID/:id" element={<StockClosingView />} />}
                    {(superAdmin || (urlList && urlList.has("/stockTransfer/{uuid}"))) && <Route path="/stockTransfer/:id" element={<StockTransferView />} />}
                    {(superAdmin || (urlList && urlList.has("/storeTransfer/getAllRecords"))) && <Route path="/storeTransfer/list" element={<StoreTransferList />} />}
                    {(superAdmin || (urlList && urlList.has("/storeTransfer/"))) && <Route path="/storeTransfer/new" element={<StoreTransferNew />} />}
                    {(superAdmin || (urlList && urlList.has("/storeTransfer/{uuid}"))) && <Route path="/storeTransfer/:id" element={<StoreTransferView />} />}

                    {/* {(superAdmin || (urlList && urlList.has("/wastage/list"))) && <Route path="/wastage/list" element={<WastageList />} />} */}
                    {/* {(superAdmin || (urlList && urlList.has("/wastage/new"))) && <Route path="/wastage/new" element={<WastageNew />} />} */}
                    {/* {(superAdmin || (urlList && urlList.has("/wastage/:warehouseID/:id"))) && <Route path="/wastage/:warehouseID/:id" element={<WastageView />} />} */}
                    {(superAdmin || (urlList && urlList.has("/wastage/warehouseList/{uuid}"))) && <Route path="/wastage/list" element={<WastageList />} />}
                    {(superAdmin || (true)) && <Route path="/salestarget" element={<FGsalesList />} />}
                    {(superAdmin || (true)) && <Route path="/salestarget/new" element={<AddEditFGitemsales />} />}
                    {(superAdmin || (true)) && <Route path="/salestarget/:id/edit" element={<AddEditFGitemsales />} />}
                    {(superAdmin || (true)) && <Route path="/salestarget/view/:id" element={<FGItemsView />} />}
                    {(superAdmin || (urlList && urlList.has("/wastage/{uuid}"))) && <Route path="/wastage/new" element={<WastageNew />} />}
                    {(superAdmin || (urlList && urlList.has("/wastage/{uuid}/{code}"))) && <Route path="/wastage/:warehouseID/:id" element={<WastageView />} />}

                    {(superAdmin || (urlList && urlList.has("/creditNote/getAllRecords"))) && <Route path="/CreditNoteView/" element={<CreditNoteView />} />}
                    {(superAdmin || (urlList && urlList.has("/debitNote/getAllRecords"))) && <Route path="/DebitNoteView/" element={<DebitNoteView />} />}
                    {(superAdmin || (urlList && urlList.has("/getRecordsByWarehouseId"))) && <Route path="/PickList" element={<PickList />} />}

                    {(superAdmin || (urlList && urlList.has("/requisition/getAllRecords"))) && <Route path="/requisition" element={<RequisitionList />} />}
                    {(superAdmin || (urlList && urlList.has("/requisition/"))) && <Route path="/requisition/new" element={<RequisitionNew />} />}
                    {(superAdmin || (urlList && urlList.has("/requisition/{uuid}"))) && <Route path="/requisition/edit" element={<RequisitionNew />} />}
                    {(superAdmin || (urlList && urlList.has("/requisition/{uuid}"))) && <Route path="/requisition/:id" element={<RequisitionView />} />}
                    {(superAdmin || (urlList && urlList.has("/departmentstockClosing/warehouseList/{warehouse}"))) && <Route path="/departmentstockClosing/list" element={<DepartmentStockClosingList />} />}
                    {(superAdmin || (urlList && urlList.has("/departmentstockClosing/{uuid}"))) && <Route path="/departmentstockClosing/new" element={<DepartmentStockClosingNew />} />}
                    {(superAdmin || (urlList && urlList.has("/departmentstockClosing/{uuid}/{code}"))) && <Route path="/departmentstockClosing/:uuid/:id" element={<DepartmentStockClosingView />} />}

                    {/* <Route path="/requisition/new" element={<IssuanceNew />} /> */}
                    {/* <Route path="/requisition/edit" element={<IssuanceNew />} /> */}


                    {/* available to all */}

                    {/* <Route path="/issueitems/:id/edit" element={<IssuanceNew />} /> */}

                    <Route path="/reports" element={<ViewReports />} />
                    <Route path="/reports/:name" element={<ViewReports />} />


                    {superAdmin && (
                        <>
                            <Route path="/settings/preferences" element={<PreferencesNav />} />
                            <Route path="/settings/preferences/DeliveryPersonList" element={<DeliveryPersonList />} />
                            <Route path="/settings/Preferences/Organization" element={<OrgList />} />
                            <Route path="/settings/Preferences/UserAndRoles" element={<UserAndRoles />} />
                            <Route path="/settings/Preferences/Warehouses" element={<Warehouses />} />
                            <Route path="/settings/Preferences/TaxList" element={<TaxList />} />
                            <Route path="/settings/preferences/TermsConditionList" element={<TermsConditionList />} />
                            <Route path="/settings/preferences/DepartmentList" element={<DepartmentList />} />
                            <Route path="/settings/preferences/UnitList" element={<UnitList />} />
                            <Route path="/settings/preferences/DefaultUrlList" element={<DefaultUrlList />} />
                            <Route path="/settings/preferences/TaxExempt" element={<TaxExempt />} />
                            <Route path="/settings/preferences/HSN" element={<HsnList />} />
                            <Route path="/settings/preferences/quality-parameter" element={<QualityParameter />} />
                            <Route path="/settings/preferences/PaymentTerms" element={<PaymentTerms />} />
                            <Route path="/settings/preferences/TDS" element={<TDSList />} />
                            <Route path="/settings/preferences/salesperson" element={<SalesPersonList />} />
                            <Route path="/settings/preferences/categories" element={<Categories />} />
                            <Route path="/settings/preferences/vendor-categories" element={<CustomCategory parentFlag={CUSTOM_CATEGORY_COMPONENT_TYPE.VENDOR_CATEGORY} />} />
                            <Route path="/settings/preferences/customer-categories" element={<CustomCategory parentFlag={CUSTOM_CATEGORY_COMPONENT_TYPE.CUSTOMER_CATEGORY} />} />
                            <Route path="/settings/preferences/sub-categories" element={<CustomCategory parentFlag={CUSTOM_CATEGORY_COMPONENT_TYPE.SUB_CATEGORY} />} />
                            <Route path="/settings/preferences/store" element={<Store />} />
                            <Route path="/settings/preferences/rack" element={<Rack />} />
                            <Route path="/settings/preferences/cell" element={<Cell />} />
                            <Route path="/settings/preferences/pallet" element={<Pallet />} />
                            <Route path="/settings/preferences/tcs-rate" element={<TCS />} />
                        </>
                    )}
                    {/* <Route path="/settings/eWay" element={<EWay />} /> */}
                    <Route path="*" element={<AccessDenied />} />
                </Routes>
            </div>
            <Toaster />
        </>
    );
};

export default Routing2;
